(function() {
    let switch_button = document.getElementsByClassName('switch-button');
    for (let i = 0; i < switch_button.length; i++) {
        switch_button[i].addEventListener('change', function() {
            this.parentNode.parentNode.style.display = 'none';
            switch (this.children[0].value) {
                //普通自動車
                case '普通自動車':
                document.getElementById('standard').style.display = 'block';
                break;
                case 'MT':
                document.getElementById('standard_mt').style.display = 'block';
                break;
                case 'AT':
                document.getElementById('standard_at').style.display = 'block';
                break;
                //準中型車
                case '準中型車':
                document.getElementById('semi_medium').style.display = 'block';
                break;
                //中型車
                case '中型車':
                document.getElementById('medium').style.display = 'block';
                break;
                //二輪車
                case '二輪車':
                document.getElementById('motorcycle').style.display = 'block';
                break;
                case '普通二輪':
                document.getElementById('motorcycle_standard').style.display = 'block';
                break;
                case '小型限定':
                document.getElementById('motorcycle_small').style.display = 'block';
                break;
            }
        });
    }
    //戻るボタン制御
    let return_btn = document.getElementsByClassName('switch-return__item');
    for (let i = 0; i < return_btn.length; i++) {
        return_btn[i].addEventListener('click', function() {

            //表示されている質問を非表示
            let display_item_id = this.parentNode.parentNode.id;
            const delete_item = document.getElementById(display_item_id);
            delete_item.style.display = 'none';

            // ひとつ戻るボタン
            if(this.dataset.return === 'one') {
                //originへ戻る
                const to_origin = ['standard', 'semi_medium', 'medium','motorcycle'];
                if(to_origin.includes(display_item_id)) {
                    document.getElementById('origin').style.display = 'block';
                }
                //standardへ戻る
                const to_standard = ['standard_mt', 'standard_at'];
                if(to_standard.includes(display_item_id)) {
                    document.getElementById('standard').style.display = 'block';
                }
                //motorcycleへ戻る
                const to_motorcycle = ['motorcycle_standard', 'motorcycle_small'];
                if(to_motorcycle.includes(display_item_id)) {
                    document.getElementById('motorcycle').style.display = 'block';
                }


            }else if(this.dataset.return === 'origin') {

                // 初めからボタン
                document.getElementById('origin').style.display = 'block';
            }
        });
    }
})();